function t(...t){return t.filter((t=>t)).join(" ")}function e(t){const e=Number.parseFloat(t);return/ms$/i.test(t)?e:1e3*e}export{t as classnames,e as parseTimeAsMillis};
